import { render, staticRenderFns } from "./Audio_management.vue?vue&type=template&id=09806a6c"
import script from "./Audio_management.vue?vue&type=script&lang=js"
export * from "./Audio_management.vue?vue&type=script&lang=js"
import style0 from "./Audio_management.vue?vue&type=style&index=0&id=09806a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports